import { render } from "./PageFormReferensi.vue?vue&type=template&id=7cf9ad22"
import script from "./PageFormReferensi.vue?vue&type=script&lang=js"
export * from "./PageFormReferensi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__